<template>
  <label
    class="ds-checkbox"
    :class="{
      'ds-checkbox--large': size === 'large',
      'ds-checkbox--disabled': isDisabled,
      'ds-checkbox--align-top': alignTop,
      [`ds-checkbox--${color}`]: !!color && ALLOWED_COLORS.includes(color),
    }"
    :data-test-id="dataTestId + '__label'"
  >
    <input
      class="ds-checkbox-input"
      type="checkbox"
      :name="name"
      :disabled="isDisabled"
      :checked="modelValue"
      :data-test-id="dataTestId"
      :aria-invalid="hasErrors && !modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
    >
    <div class="ds-checkbox-indicator" />
    <slot
      v-if="$slots.default"
    />
    <span
      v-if="label"
      class="ds-checkbox-text"
    >{{ label }}</span>
  </label>
</template>

<script>
import htmlProps from '../htmlProps.js';
import commonPropsMixin from './common-props-mixin.js';
import validation from './validation-mixin';

// Define allowed colors from design system
const ALLOWED_COLORS = ['green', 'red', 'orange', 'brown', 'blue', 'purple', 'teal', 'grey', 'yellow', 'white', 'black'];

export default {
  name: 'CheckboxField',
  emits: ['update:modelValue'],
  mixins: [htmlProps, commonPropsMixin, validation],
  props: {
    modelValue: {
      type: Boolean,
    },
    // eslint-disable-next-line vue/require-default-prop
    label: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
      validator: (size) => {
        return ['', 'medium', 'large'].includes(size);
      },
    },
    alignTop: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'green', // default, shouldn't add any modifier class
      validator: (color) => {
        return color === '' || ALLOWED_COLORS.includes(color);
      },
    },
  },
  created() {
    // Make ALLOWED_COLORS available in template
    this.ALLOWED_COLORS = ALLOWED_COLORS;
  },
};
</script>
